import DatePicker from "react-datepicker";
import { CalendarIcon } from "../icons";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { enUS, ja } from "date-fns/locale";

const IconInputDate = ({
    index,
    lang,
    selectedDate,   // Date | null
    onSelectDate,
    onRemoveDate,
    placeholder = "Select Date"
}) => {
    const hasValue = Boolean(selectedDate);

    const dateFormat = {
        EN: "MMM. Do, YYYY (ddd)",
        JP: "YYYY年M月D日（ddd）"
    };

    const displayValue = selectedDate
        ? moment(selectedDate).format(dateFormat[lang])
        : "";

    return (
        <DatePicker
            locale={lang === "EN" ? enUS : ja}
            selected={selectedDate}
            minDate={new Date()}
            onSelect={(date) => {
                const formatedDate = date.toLocaleDateString("sv-SE", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                });
                onSelectDate(formatedDate, index)
            }}
            customInput={
                <div
                    className="
                        tw:!relative
                        tw:!flex tw:!items-center
                        tw:!border tw:!border-[#DADADA]
                        focus-within:tw:!border-[#4E4E4E]
                        tw:!rounded-md
                        tw:!px-3
                        tw:!py-3
                        tw:!transition-colors tw:!duration-150
                    "
                >
                    {/* Icon */}
                    <div className="tw:!mr-2">
                        <CalendarIcon color="#DBBE78" />
                    </div>

                    {/* Input */}
                    <input
                        readOnly
                        autoComplete="off"
                        type="text"
                        value={displayValue}
                        className={`
                            tw:!w-full
                            tw:!outline-none
                            tw:!bg-transparent
                            tw:!text-[15px]
                            tw:!font-[400]
                            tw:!font-[var(--font-sans-primary)]
                            ${hasValue
                                ? "tw:!text-[#4E4E4E]"
                                : "tw:!text-[#A7A7A7]"}
                        `}
                    />

                    {/* Clear */}
                    {hasValue && (
                        <div className="tw:!ml-2">
                            <i
                                className="fa fa-close tw:!cursor-pointer"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRemoveDate(index);
                                }}
                            />
                        </div>
                    )}

                    {/* Placeholder */}
                    {!hasValue && (
                        <label
                            className="
                                tw:!absolute
                                tw:!left-10
                                tw:!text-[#A7A7A7]
                                tw:!pointer-events-none
                                tw:!text-[15px]
                            "
                        >
                            {placeholder}
                        </label>
                    )}
                </div>
            }
        />
    );
};

export default IconInputDate;
